import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AppLogsRaw = React.lazy(() => import(/* webpackChunkName: "AppLogsPage" */ './AppLogs'));
export const AppLogs = () => (React.createElement(Page, { title: "Application Logs", description: "Application Logs" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AppLogsRaw, null)))));
